/* 个人中心管理 */
import request from '../utils/request'

export const getProfileAPI = () => {
	return request({
		url: '/user/profile',
		method: 'get',
	})
}

/* 修改头像 */
export const updatedAvatarAPI = data => {
	return request({
		url: '/user/avatar',
		method: 'post',
		data,
	})
}

/* 修改密码 */
export const updatedPasswordAPI = data => {
	return request({
		url: '/user/reset_password',
		method: 'post',
		data,
	})
}

/* 第三方登录绑定详情 */
export const getBindListAPI = () => {
	return request({
		url: '/user/bind_list',
		method: 'get',
	})
}

/* 解除绑定第三方 */
export const unBindListPlatformAPI = data => {
	return request({
		url: '/user/unbind',
		method: 'post',
		data,
	})
}

